<template>
	<page>
		<module title="今日实时概况" height="auto">
			<template #head>
				<div class="handle flex-end-center">更新时间：{{realtimeDate}}</div>
			</template>
			
			<div class="flex">
				<div class="total flex-wrap">
					<div v-for="(item, i) in totalData" :key="i" class="item flex-column flex-center-main">
						<p>{{item.name}}</p>
						<strong>{{item.tody_count}}</strong>
						<div>
							<span>昨日：{{item.yesterday_count}}</span>
							<span>{{Math.abs(item.ratio)}}% 
								<i v-if="item.tody_count > item.yesterday_count" class="tf tf-sort-up" style="color: #F03526"></i>
								<i v-else-if="item.tody_count < item.yesterday_count" class="tf tf-sort-down" style="color: #2AC0B4"></i>
							</span>
						</div>
					</div>
				</div>
				<div class="flex-grow">
					<div class="tab flex-end">
						<div v-for="(item, i) in tabList" :key="i" class="item" :class="{'z-crt': currentTab == item}" @click="currentTab = item">{{item.name}}</div>
					</div>
					
					<charts type="line" :data="this[currentTab.value]" height="275"></charts>
				</div>
			</div>
		</module>
		
		<div class="flex flex-grow-auto">
			<module class="flex-grow" title="待处理业务" style="width: 50%; margin-top: 10px;">
				<div class="business flex-wrap">
					<div v-for="(item, i) in backlogList" :key="i" class="item" @click="navigateTo(item.to_page)">
						<div>{{item.value}}</div>
						<p>{{item.name}}</p>
					</div>
				</div>
			</module>
			<module class="flex-grow" title="售后动态" style="width: 50%; margin-left: 10px;">
				<template #head>
					<div class="handle flex-end-center"><c-link @click="navigateTo('/after_sale_list')">更多</c-link></div>
				</template>
					
				<charts type="line" line-area :data="afterSalesList" height="330"></charts>
			</module>
		</div>
		
		<module title="销售动态" height="auto" style="margin-top: 10px;">
			<template #head>
				<div class="handle flex-end-center"><c-link @click="navigateTo('/order_list')">更多</c-link></div>
			</template>
			
			<charts type="line" line-area :data="salesList" height="460"></charts>
		</module>
	</page>
</template>

<script>
	import charts from '@/components/charts/index.vue'
	
	export default {
		components: {
			charts
		},
		
		data() {
			return {
				realtimeDate: '',
				totalData: [],
				
				tabList: [{
					name: '支付金额',
					value: 'payList'
				}, {
					name: '退款',
					value: 'refundList'
				}/*, {
					name: '退货',
					value: 'returnList'
				}*/],
				currentTab: '',
				
				payList: [],
				refundList: [],
				returnList: [],
				
				backlogList: [],
				
				afterSalesList: [],
				salesList: []
			}
		},
		
		created() {
			this.currentTab = this.tabList[0];
		},
		
		mounted() {
			this.updateRealTime();
			this.updateBacklog();
			this.updateAfterSales();
			this.updateSales();
		},
		
		beforeDestroy() {
			clearTimeout(this._realTimer);
		},
		
		methods: {
			updateRealTime() {
				this.request({
					url: '/stationed/workbench/today',
					success: data => {
						this.realtimeDate = data.nowTime;
						this.totalData = data.toDayList;
						['payList', 'refundList', 'returnList'].forEach(key => {
							this[key] = [{
								type: '今天',
								data: Array.from(data[key], item => {
									return {
										name: item.title,
										value: item.tody_count
									}
								})
							}, {
								type: '昨天',
								data: Array.from(data[key], item => {
									return {
										name: item.title,
										value: item.yesterday_count
									}
								})
							}];
						})
					}
				})
				
				this._realTimer = setTimeout(this.updateRealTime, 10000);
			},
			
			updateBacklog() {
				this.request({
					url: '/stationed/workbench/stayItem',
					success: data => {
                        console.log('----stationed/workbench/stayItem-----')
                        console.log(data)
						this.backlogList = data;
					}
				})
			},
			
			updateAfterSales() {
				this.request({
					url: '/stationed/workbench/returnDynamic',
					success: data => {
						this.afterSalesList = [{
							type: '退款金额',
							data: Array.from(data, item => {
								return {
									name: item.title,
									value: item.refund_money
								}
							})
						}, {
							type: '退货金额',
							data: Array.from(data, item => {
								return {
									name: item.title,
									value: item.return_money
								}
							})
						}];
					}
				})
			},
			
			updateSales() {
				this.request({
					url: '/stationed/workbench/saleDynamic',
					success: data => {
						this.salesList = [{
							type: '订单金额',
							data: Array.from(data, item => {
								return {
									name: item.title,
									value: item.placean_order_money
								}
							})
						}, {
							type: '支付金额',
							data: Array.from(data, item => {
								return {
									name: item.title,
									value: item.payment_money
								}
							})
						}];
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.handle {
		height: 100%;
		padding-right: 20px;
		font-size: 12px;
		color: #999;
	}
	
	.total {
		width: 530px;
		margin-top: 30px;
		
		.item {
			box-sizing: border-box;
			width: 50%;
			height: 110px;
			padding-left: 25px;
			
			&:nth-child(n+3) {
				margin-top: 20px;
			}
			
			p {
				font-size: 14px;
				color: #666;
			}
			
			strong {
				margin: 10px 0 14px;
				font-size: 24px;
			}
			
			span {
				margin-right: 1em;
				font-size: 12px;
				color: #666;
			}
		}
	}
	
	.tab {
		margin-top: 14px;
		margin-right: 22px;
		
		.item {
			position: relative;
			width: 62px;
			border: 1px solid #ddd;
			margin-left: -1px;
			line-height: 25px;
			font-size: 12px;
			text-align: center;
			color: #999;
			cursor: pointer;
			
			&.z-crt {
				z-index: 1;
				border-color: var(--color-main);
				color: #fff;
				background: var(--color-main);
			}
			
			&:not(.z-crt):hover {
				z-index: 1;
				border-color: var(--color-main);
				color: var(--color-main);
			}
		}
	}
	
	.business {
		padding: 20px 18px 0;
		
		.item {
			width: calc(33.3333% - 14px);
			padding: 14px 0;
			margin-bottom: 20px;
			margin-left: 20px;
			text-align: center;
			background: #F9F9F9;
			cursor: pointer;
			
			&:nth-child(3n+1) {
				margin-left: 0;
			}
			
			&:hover {
				background: var(--color-main);
				
				div, p {
					color: #fff;
				}
			}
			
			div {
				margin-bottom: 8px;
				font-size: 30px;
				font-weight: bold;
			}
			
			p {
				font-size: 13px;
				color: #999;
			}
		}
	}
</style>
